// extracted by mini-css-extract-plugin
module.exports = {"BigButton":"styles_BigButton__VpM7D","disabled":"styles_disabled__kOSNA","childrenContent":"styles_childrenContent__1Axb0","isOutOfStock":"styles_isOutOfStock__QNomA"};